export default __webpack_public_path__ + "static/media/image-03.e05cdf8b.png";